export default __webpack_public_path__ + "static/media/artistBanner1.5239f015.png";